import { useColorScheme } from '@mui/material/styles';

/** Resolved light/dark mode plus a toggle (persisted by MUI's color-scheme storage). */
export function useThemeMode() {
  const { mode, systemMode, setMode } = useColorScheme();
  const isDark = (mode === 'system' ? systemMode : mode) === 'dark';
  return { isDark, toggle: () => setMode(isDark ? 'light' : 'dark') };
}
